import { UserAccount, UserOnboardingStatus } from "src/types/User";
import { isNonCdlVocation } from "src/types/Vocation";

export default function isUserOnboarded(user: UserAccount) {
  // Non-CDL students are "onboarded" once their application is in:
  // no application yet → the survey; submitted → home ("Application
  // received"). The CDL statuses below never apply to them (R4: their
  // applicationStatus is only ever set manually by ops).
  if (isNonCdlVocation(user.vocationId)) {
    return Boolean(user.application);
  }
  return (
    user.onboardingStatus === UserOnboardingStatus.ENROLLED ||
    user.onboardingStatus === UserOnboardingStatus.COMPLETED_THEORY ||
    user.onboardingStatus === UserOnboardingStatus.RANGE ||
    // On-hold users are only considered onboarded if they've completed success plan setup
    // (user.applicationStatus === "on_hold" && !!user.theoryTrainingPlan) ||
    user.applicationStatus === "on_hold" ||
    (user.applicationStatus === "conditionally_enrolled" && !!user.schoolId) ||
    user.applicationStatus === "enrolled" ||
    user.enrollmentStatus === "theory_training" ||
    user.enrollmentStatus === "completed_theory_training" ||
    user.enrollmentStatus === "completed_skills_training" ||
    user.enrollmentStatus === "skills_training" ||
    user.enrollmentStatus === "licensed"
  );
}
